import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import { IContactPersonViewModel } from "../../../../../../Scripts/inpulse/I4UViewModels";
import { ContactPersonUtils } from "../../../../../../Scripts/inpulse/ContactPersonUtils";
import { AddressFormat } from "../../../../../../Scripts/inpulse/AddressFormat";

@Component({

})

export default class ContactPersonCard extends Vue {
    @Prop()
    title: string;
    @Prop()
    contactPerson: IContactPersonViewModel;
    @Prop({ default: true })
    editable: boolean;

    @Emit()
    modify() {}

    constructor() {
        super();
    }

    get name(): string {
        let str = "";
        if (this.contactPerson.FirstName)
            str += this.contactPerson.FirstName;
        if (this.contactPerson.LastName) {
            if (str)
                str += " ";
            str += this.contactPerson.LastName
        }
        if (this.contactPerson.Pin) {
            if (str)
                str += ", ";
            str += this.contactPerson.Pin;
        }
        return str;
    }

    get addressString(): string {
        return AddressFormat.toSingleString(this.contactPerson.Address);
    }

    get isEmpty(): boolean {
        return ContactPersonUtils.isEmpty(this.contactPerson);
    }
}